import { forwardRef } from 'react';
import styles from './Textarea.module.css';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { error, className, rows = 3, ...props },
  ref
) {
  const classes = [styles.textarea, error && styles.error, className].filter(Boolean).join(' ');
  // Autofill off by default, for the reasons spelled out in Input.tsx — every
  // textarea here is notes about someone else, never the user's own credentials.
  // Before `{...props}` so a caller can still opt back in.
  return (
    <textarea
      ref={ref}
      className={classes}
      rows={rows}
      autoComplete="off"
      data-1p-ignore=""
      data-lpignore="true"
      {...props}
    />
  );
});
